import * as React from 'react'
import LazyLoad, { LazyLoadProps } from 'react-lazyload'

interface IProps extends LazyLoadProps {
  lazyLoad: boolean
}

export default function ConditionalLazyLoad(props: IProps) {
  const { lazyLoad, ...rest } = props

  return lazyLoad ? <LazyLoad {...rest} /> : <React.Fragment>{props.children}</React.Fragment>
}
